import { Message } from '../types';

/**
 * Creates optimistic user and thinking messages for immediate UI display
 * while the backend processes the request.
 */
export const createOptimisticMessages = (
  messageText: string,
  attachmentFileName?: string
): { userMessage: Message; thinkingMessage: Message } => {
  const userMessage: Message = {
    id: `temp-${Date.now()}`,
    text: messageText,
    sender: 'You',
    timestamp: new Date().toISOString(),
    attachmentFileName,
  };

  const thinkingMessage: Message = {
    id: `thinking-${Date.now()}`,
    text: 'Thinking...',
    sender: 'Acconto.ai',
    timestamp: new Date().toISOString(),
    isThinking: true,
  };

  return { userMessage, thinkingMessage };
};
